export default __webpack_public_path__ + "1afa37cc1e8232409d31fe2eebdc26b6.svg";